const commonPath = {
  erp: '/erp'
};

export default commonPath;
